// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__3fKz5","box":"WorkspacesBox_box__HJiXk","node":"WorkspacesBox_node__sR7WU"};